export const config = {
  title: 'Quezada Construction Services LLC',
  meta: {
    description:
      'Quezada Construction Services LLC offers quality construction and renovation services in Georgia, specializing in new home construction, remodeling, framing, drywall, electrical installation, plumbing, painting, and tile installation.',
    keywords: [
      'Construction Services',
      'Home Remodeling',
      'Framing',
      'Drywall Installation',
      'Electrical Installation',
      'Plumbing Services',
      'Painting Services',
      'Tile Installation',
      'Quezada Construction Services LLC',
      'Georgia Construction Company',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'Quezada Construction Services LLC',
    canonicalUrl: 'https://quezadaconstruction.com/',
  },
  sections: {
    header: {
      businessName: 'Quezada Construction Services LLC',
    },
    sectionB: {
      heroTitle: 'Quezada Construction Services LLC',
      heroSubtitle: 'Your Vision, Our Expertise in Quality Construction & Renovation',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '7708955308',
      phoneLabel: '(770) 895-5308',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1345384816/photo/construction-industry-and-engineering-in-post-recession-period.jpg?s=612x612&w=0&k=20&c=3sK6hLkePixyVhbjrSDKATOx9cVnbor2d2qASBkUucM=',
      cardData: [
        {
          title: 'Experienced Professionals',
          description:
            'Over 15 years of experience in delivering exceptional construction and renovation services.',
        },
        {
          title: 'Comprehensive Services',
          description:
            'From new home construction to complete remodels, we handle all aspects of your project.',
        },
        {
          title: 'Quality Craftsmanship',
          description:
            'Committed to excellence and attention to detail in every project we undertake.',
        },
      ],
      description:
        'At Quezada Construction Services LLC, we specialize in building new homes and executing both partial and complete remodels. Our services include framing, drywall, electrical installation, plumbing, painting, and tile installation, ensuring top-notch quality and customer satisfaction.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of construction and renovation services designed to bring your vision to life.',
      cards: [
        {
          title: 'New Home Construction',
          description:
            'Building your dream home from the ground up with expert craftsmanship.',
          imageSrc: 'https://img1.wsimg.com/isteam/stock/3208/:/rs=w:370,cg:true,m',
          imageAlt: 'New Home Construction',
        },
        {
          title: 'Home Remodeling',
          description:
            'Transforming your existing space into a modern and functional environment.',
          imageSrc: 'https://img1.wsimg.com/isteam/ip/1a619ebc-d466-41b5-8b1c-aa5d5c21c3ad/Imagen%20de%20WhatsApp%202025-02-14%20a%20las%2018.32.53_9.jpg/:/cr=t:0%25,l:7.81%25,w:84.38%25,h:100%25/rs=w:370,cg:true',
          imageAlt: 'Home Remodeling',
        },
        {
          title: 'Framing & Drywall',
          description:
            'Providing sturdy framing and flawless drywall installation for your projects.',
          imageSrc: 'https://img1.wsimg.com/isteam/stock/100886/:/rs=w:1160',
          imageAlt: 'Framing and Drywall',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Electrical Installation',
        'Plumbing Services',
        'Painting Services',
        'Tile Installation',
        'Flooring Installation',
        'Roofing Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://img1.wsimg.com/isteam/ip/1a619ebc-d466-41b5-8b1c-aa5d5c21c3ad/428641077_414919351193702_1816027820283133118_.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:370,cg:true',
        alt: 'Quezada Construction Services LLC Team',
      },
      aboutText: [
        'With over 15 years of experience, Quezada Construction Services LLC has been a trusted name in the construction industry, delivering exceptional craftsmanship and attention to detail.',
        'Our mission is to build and transform homes with unmatched reliability and innovation, ensuring every project reflects excellence and customer satisfaction.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Quezada Construction Services LLC Logo',
      businessName: 'Quezada Construction Services LLC',
      contact: {
        phone: '7708955308',
        phoneLabel: '(770) 895-5308',
        email: 'miguelquezada34@gmail.com',
        website: 'https://quezadaconstruction.com/',
        address: 'Lawrenceville, GA 30044',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Lawrenceville, GA 30044',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.123456789012!2d-84.1234567!3d33.9567890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1234567890%3A0xabcdef1234567890!2sLawrenceville%2C%20GA%2030044!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus',
    },
  },
};

export default config;
